import React, { Component } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import LoadingScreen from "../../../helpers/LoadingScreen";
import * as helpers from "../../../helpers/helpers";
import * as vHelpers from "./../../../helpers/vHelpers";
import "./Reports.scss";

import mainConfig from "../../../config.json"

const layerNames = ['rurova_siet', "odvodnovaci_kanal_hmsp", "zavlahovy_kanal_hmsp"];
const excludedWords = ['geom', 'geometry', 'geometria', 'RawGeometry', 'rawGeometry', 'id', "dlzka"];
// const excludedWords = ['geom', 'geometry', 'geometria', 'RawGeometry', 'rawGeometry', 'pdf', pdf2','id'];

class Reports extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeIndexes_C: new Set(),
      activeIndexes_E: new Set(),
      zoom: false,
      dropdownIcons: {},
      dropdownIcons_C: {},
      dropdownIcons_E: {},
      parcelyData_C: [],
      parcelyData_E: [],
      isLoading: false,
      addIcon: "add",
      windowHeight: window.innerHeight
    };

    window.emitter.addListener("activateReportLoading", () => {
      this.setState({ isLoading: true });
    });

    window.emitter.addListener("activateReportContent", (data) => {
      this.setData(data);
    });
  }

  componentDidMount() {    
    window.addEventListener('resize', this.handleResizeReports);
  
    // Volanie funkcie pre aktualizáciu výšky elementu
    this.updateElementHeight();
  }

  handleResizeReports = () => {
    this.setState({
      windowHeight: window.innerHeight,
    }, () => {
      this.updateElementHeight(); // Zavolajte aktualizáciu výšky cieľového elementu po nastavení stavu
    });
  };

  updateElementHeight = () => {
    const targetElement = document.getElementById('reports-container');
    if (targetElement) {
      const newHeight = this.state.windowHeight - 113;
      targetElement.style.height = `${newHeight}px`;
    }
  };

  async setData(data) {

    const { c: parcelyData_C, e: parcelyData_E = [], layerName } = data;
  
    let message = "";
    if (parcelyData_E === -1 && parcelyData_C === -1) {
      message = "Priveľa výsledkov z registra C a E. Použite prosím katastrálnu mapu.";
    } else if (parcelyData_C === -1) {
      message = "Priveľa výsledkov z registra C. Použite prosím katastrálnu mapu.";
    } else if (parcelyData_E === -1) {
      message = "Priveľa výsledkov z registra E. Použite prosím katastrálnu mapu.";
    }
  
    if (message) {
      helpers.showMessage(
        "Výsledok nie je možné zobraziť",
        message,
        helpers.messageColors.red,
        9000
      );
    }
    window.emitter.emit("closePopup");
  
    if (parcelyData_E === -1 && parcelyData_C === -1) {
      return;
    } else {
      this.setState({ parcelyData_C, parcelyData_E, layerName }); // Nastavíme layerName do state
    }
  }
  
  // Separate fetchData to reuse
  // async setData(data) {
  //   const parcelyData_C = data.c;
  //   const parcelyData_E = data.e || [];
  //   const layerName = data.layerName;
  
  //   let message = "";
  //    if (parcelyData_E === -1 && parcelyData_C === -1) {
  //       message = "Priveľa výsledkov z registra C a E. Použite prosím katastrálnu mapu.";
  //   } else if (parcelyData_C === -1) {
  //     message = "Priveľa výsledkov z registra C. Použite prosím katastrálnu mapu.";
  //   } else if (parcelyData_E === -1) {
  //       message = "Priveľa výsledkov z registra E. Použite prosím katastrálnu mapu.";
  //   } 
  
  //   if (message) {
  //     helpers.showMessage(
  //       "Výsledok nie je možné zobraziť",
  //       message,
  //       helpers.messageColors.red,
  //       9000,
  //     );
  //   }
  //   window.emitter.emit("closePopup");

  //   if (parcelyData_E === -1 && parcelyData_C === -1) {
  //       return
  //   }  else {
  //       this.setState({ parcelyData_C, parcelyData_E });
  //   }
  // }

  handleClick = (type, e, titleProps) => {
    const { index } = titleProps;
    const currentState = type === 'C' ? this.state.activeIndexes_C : this.state.activeIndexes_E;
    const newIndexes = new Set(currentState);
    if (newIndexes.has(index)) {
      newIndexes.delete(index);
    } else {
      newIndexes.add(index);
    }

    const newIcon = newIndexes.has(index) ? "angle up" : "angle down";

    if (type === 'C') {
      this.setState({
        activeIndexes_C: newIndexes,
        dropdownIcons_C: {
          ...this.state.dropdownIcons_C,
          [index]: newIcon,
        },
      });
    } else {
      this.setState({
        activeIndexes_E: newIndexes,
        dropdownIcons_E: {
          ...this.state.dropdownIcons_E,
          [index]: newIcon,
        },
      });
    }
  };


  handleZoomClick = (evt, parcela) => {
    evt.stopPropagation();
    const tabname = `Parcela č.${parcela.parcelno}`
    const features = vHelpers.getProcessedFeatures(parcela, undefined, tabname, "kn");

    window.emitter.emit(
      "removeRenderedFeature",
      "bothBySource",
      null,
      "filter"
    );
    window.emitter.emit(
      "removeRenderedFeature",
      "bothBySource",
      null,
      "uri"
    );
    window.emitter.emit(
      "removeRenderedFeature",
      "bothBySource",
      null,
      "kn"
    );
    window.emitter.emit("removeRenderedFeature", "allHighlights");

    // window.emitter.emit(
    //   "renderFeature",
    //   features,
    //   tabname,
    //   tabname,
    //   tabname,
    //   "kn",
    //   true
    //   // "255, 255, 0"
    // );

    window.emitter.emit(
      "openAttTabGEOJSON",
      tabname,
      features,
      tabname,
      "kn",
      tabname,
      null,
      false
    );
  };

  handleAllDataZoomClick = (evt, data, parcelType) => {
    evt.stopPropagation();
    this.removeSelections("C");
    this.removeSelections("E");

    const features = vHelpers.getProcessedFeatures(data, "api_url", "Parcela", "kn");

    if (parcelType === "C") {
      window.emitter.emit(
        "renderFeature",
        features,
        "kn",
        "Parcely registra C",
        "Parcely registra C",
        "reportC",
        true,
        "200, 110, 190"
      );
    } else if (parcelType === "E") {
      window.emitter.emit(
        "renderFeature",
        features,
        "kn",
        "Parcely registra E",
        features[0].tabNamparcelnoe,
        "reportE",
        true,
        "200, 110, 190"
      );
    }

  }

  removeSelections = (parcelType) => {
    if (parcelType === "C") {
      window.emitter.emit(
        "removeRenderedFeature",
        "bothBySource",
        null,
        "reportC"
      );
    } else if (parcelType === "E") {
      window.emitter.emit(
        "removeRenderedFeature",
        "bothBySource",
        null,
        "reportE"
      );
    }
  }

  onToggleFilter = () => {
    const newIndex = this.state.toggleActiveIndex === 1 ? 0 : 1;
    const newIcon =
      this.state.toggleActiveIndex === 1 ? "angle up" : "angle down";
    this.setState({ toggleActiveIndex: newIndex, dropdownIcon: newIcon });
  };

  // handleAddButton = (evt, parcela) => {
  //   evt.stopPropagation();

  //   console.log("handleAddButton, parcela", parcela);

  //   if (this.state.addIcon === "check") return;
  //   this.setState({ addIcon: "check" });

  //   const filterResults = window.filterResults;
  //   console.log("filterResults", filterResults);

  //   const item = {
  //     name: this.state.title,
  //     layerName: this.state.layerName,
  //     geoJson: [],
  //     serverUrl: window.config.geoserverUrl,
  //     cqlFilter: null,
  //     maxRecords: null,
  //     sortFields: null,
  //     scrollTop: 0,
  //     id: this.state.title,
  //     alias: [this.state.layerName, this.state.id].join("_"),
  //   };
  //   console.log("item", item);
  //   window.filterResults = [...filterResults, item];
  //   helpers.showMessage(
  //     "Oznámenie",
  //     "Vybraný objekt je teraz dostupný v Manažmente výsledkov.",
  //     helpers.messageColors.green,
  //     4000,
  //   );
  //   console.log("filterResults", window.filterResults);
  // };

  addReportToPreviousResult(evt, parcela) {
    evt.stopPropagation();

    const tabname = `Parcela č.${parcela.parcelno}`
    const feature = vHelpers.getProcessedFeatures(parcela, undefined, tabname, "kn");

    const item = {
      name: "this.state.title",
      layerName: "this.state.layerName",
      geoJson: feature,
      // serverUrl: window.config.geoserverUrl,
      cqlFilter: null,
      maxRecords: null,
      sortFields: null,
      scrollTop: 0,
      id: "this.state.title",
      alias: "item",
    };

    console.log("item", item);
    window.filterResults = [...window.filterResults, item];
    window.emitter.emit("setPreviousResults");
    // window.dispatchEvent(new Event("filterResultsChanged"));
  };

  render() {
    const { parcelyData_C, parcelyData_E, layerName } = this.state;
    const showLengths = layerNames.includes(layerName); // Kontrola prítomnosti layerName
  
    return (
      <div id="reports-container">
        <LoadingScreen
          visible={this.state.isLoading}
          message="Čaká sa na server..."
          spinnerSize={60}
          spinnerBackColor={"#c3c3c3"}
          spinnerForeColor={"rgba(0, 58, 103, 0.85)"}
          fontSize={"26px"}
          messageColor={"rgba(0, 58, 103, 0.85)"}
          backgroundColor={"#ccffff"}
          backgroundOpacity={0.35}
        />
  
        <div className="title-h3">Kataster nehnuteľností</div>
        
        {parcelyData_C && parcelyData_C.length > 0 && (
          <div>
            <div className="section-header-container">
              <div className="title-h4">Parcely registra C</div>
              <div className="section-header-right-group">
                <div className="reports-clear-icon" onClick={() => this.removeSelections("C")} title="Vymazať z mapy">
                  <span className="material-icons md-48">clear</span>
                </div>
                <Icon
                  name="zoom"
                  className="reports-header-zoom-icon"
                  title="Zobraziť všetky výsledky na mape"
                  onClick={(evt) => this.handleAllDataZoomClick(evt, parcelyData_C, "C")}
                />
              </div>
            </div>
            <div className="section-container">
              {parcelyData_C.map((parcela, i) => (
                 <Accordion key={`parcela-C-${parcela.id}-${i}`}>
                  <Accordion.Title
                    active={this.state.activeIndexes_C.has(i)}
                    index={i}
                    onClick={(e, titleProps) => this.handleClick('C', e, titleProps)}
                    className="accordion-title"
                  >
                    <div className="item-header main">
                      <div className="item-leftGroup">
                        <div className="item-title">
                          {`Parcela č. ${parcela.parcelno}`}
                        </div>
                      </div>
                      <div className="item-rightGroup">
                      {showLengths && <span style={{ paddingRight: "10px" }}>{parcela.dlzka} m</span>}
                        {parcela.pdf && (
                          <>
                            <a
                              href={`${mainConfig.apiUrlEsprit}kataster/pdf/${parcela.pdf2}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              id="reports-pdf-icon"
                              title="Čiastočný výpis z listu vlastníctva"
                            >
                              <Icon name="file pdf outline" />
                            </a>
                            <a
                              href={`${mainConfig.apiUrlEsprit}kataster/pdf/${parcela.pdf2}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              id="reports-pdf-icon"
                              title="Výpis z listu vlastníctva"
                            >
                              <Icon name="file pdf" />
                            </a>
                          </>
                        )}
                        <Icon
                          name="zoom"
                          id="reports-zoom-icon"
                          title="Zobraziť na mape"
                          onClick={(evt) => this.handleZoomClick(evt, parcela)}
                        />
                        <Icon
                          name={this.state.dropdownIcons_C[i] || "angle down"}
                          id="reports-dropdown-icon"
                        />
                      </div>
                    </div>
                  </Accordion.Title>
                  <Accordion.Content active={this.state.activeIndexes_C.has(i)} className="accordion-content">
                    <div className="parcel-info">
                      <ul>
                      {Object.entries(parcela).map(([key, value], index) => {
                          if (!excludedWords.includes(key) && key !== "pdf" && key !== "pdf2") {
                            const attFromConfig = window.config.layerAttributesForPopup["kn"];
                            let attArray = [];
                            if (attFromConfig) {
                              attFromConfig.forEach((att) => attArray.push(att.field));

                              if (attArray.includes(key)) {
                                attFromConfig.forEach((att) => {
                                  if (att["field"] === key) key = att["alias"];
                                });
                              }
                            }
                            if (Array.isArray(value)) {
                              const combinedValue = value.join(', ');
                              return (
                                <li key={index}>
                                  <strong dangerouslySetInnerHTML={{ __html: `${key.charAt(0).toUpperCase() + key.slice(1)}: ` }}></strong>
                                  <span>{combinedValue}</span>
                                </li>
                              );
                            } else if (typeof value === "object" && value !== null) {
                              return (
                                <li key={index}>
                                  <strong dangerouslySetInnerHTML={{ __html: `${key.charAt(0).toUpperCase() + key.slice(1)}: ` }}></strong>
                                  <ul>
                                    {Object.entries(value).map(([key2, value2], innerIndex) => (
                                      <li key={innerIndex} className="inner-list">
                                        {`${key2.charAt(0).toUpperCase() + key2.slice(1)}: ${value2}`}
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              );
                            } else {
                              return (
                                <li key={index}>
                                  <strong dangerouslySetInnerHTML={{ __html: `${key.charAt(0).toUpperCase() + key.slice(1)}: ` }}></strong>
                                  <span>{value}</span>
                                </li>
                              );
                            }
                          }
                          return null;
                        })}
                      </ul>
                    </div>
                  </Accordion.Content>
                </Accordion>
              ))}
            </div>
          </div>
        )}
  
        {parcelyData_E && parcelyData_E.length > 0 && (
          <div>
            <div className="section-header-container">
              <div className="title-h4">Parcely registra E</div>
              <div className="section-header-right-group">
                <div className="reports-clear-icon" onClick={() => this.removeSelections("E")} title="Vymazať z mapy">
                  <span className="material-icons md-48">clear</span>
                </div>
                <Icon
                  name="zoom"
                  className="reports-header-zoom-icon"
                  title="Zobraziť všetky výsledky na mape"
                  onClick={(evt) => this.handleAllDataZoomClick(evt, parcelyData_E, "E")}
                />
              </div>
            </div>
            <div className="section-container">
              {parcelyData_E.map((parcela, i) => (
                <Accordion key={`parcela-E-${parcela.id}-${i}`}>
                  <Accordion.Title
                    active={this.state.activeIndexes_E.has(i)}
                    index={i}
                    onClick={(e, titleProps) => this.handleClick('E', e, titleProps)}
                    className="accordion-title"
                  >
                    <div className="item-header main">
                      <div className="item-leftGroup">
                        <div className="item-title">
                          {`Parcela č. ${parcela.parcelno}`}
                        </div>
                      </div>
                      <div className="item-rightGroup">
                      {showLengths && <span style={{ paddingRight: "10px" }}>{parcela.dlzka} m</span>}
                        {parcela.pdf && (
                          <>
                            <a
                              href={`${mainConfig.apiUrlEsprit}kataster/pdf/${parcela.pdf2}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              id="reports-pdf-icon"
                              title="Čiastočný výpis z listu vlastníctva"
                            >
                              <Icon name="file pdf outline" />
                            </a>
                            <a
                              href={`${mainConfig.apiUrlEsprit}kataster/pdf/${parcela.pdf}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              id="reports-pdf-icon"
                              title="Výpis z listu vlastníctva"
                            >
                              <Icon name="file pdf" />
                            </a>
                          </>
                        )}
                        <Icon
                          name="zoom"
                          title="Zobraziť na mape"
                          onClick={(evt) => this.handleZoomClick(evt, parcela)}
                        />
                        <Icon
                          name={this.state.dropdownIcons_E[i] || "angle down"}
                          id="reports-dropdown-icon"
                        />
                      </div>
                    </div>
                  </Accordion.Title>
                  <Accordion.Content active={this.state.activeIndexes_E.has(i)} className="accordion-content">
                    <div className="parcel-info">
                      <ul>
                      {Object.entries(parcela).map(([key, value], index) => {
                          if (!excludedWords.includes(key) && key !== "pdf" && key !== "pdf2") {
                            const attFromConfig = window.config.layerAttributesForPopup["kn"];
                            let attArray = [];
                            if (attFromConfig) {
                              attFromConfig.forEach((att) => attArray.push(att.field));

                              if (attArray.includes(key)) {
                                attFromConfig.forEach((att) => {
                                  if (att["field"] === key) key = att["alias"];
                                });
                              }
                            }
                            if (Array.isArray(value)) {
                              const combinedValue = value.join(', ');
                              return (
                                <li key={index}>
                                  <strong dangerouslySetInnerHTML={{ __html: `${key.charAt(0).toUpperCase() + key.slice(1)}: ` }}></strong>
                                  <span>{combinedValue}</span>
                                </li>
                              );
                            } else if (typeof value === "object" && value !== null) {
                              return (
                                <li key={index}>
                                  <strong dangerouslySetInnerHTML={{ __html: `${key.charAt(0).toUpperCase() + key.slice(1)}: ` }}></strong>
                                  <ul>
                                    {Object.entries(value).map(([key2, value2], innerIndex) => (
                                      <li key={innerIndex} className="inner-list">
                                        {`${key2.charAt(0).toUpperCase() + key2.slice(1)}: ${value2}`}
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              );
                            } else {
                              return (
                                <li key={index}>
                                  <strong dangerouslySetInnerHTML={{ __html: `${key.charAt(0).toUpperCase() + key.slice(1)}: ` }}></strong>
                                  <span>{value}</span>
                                </li>
                              );
                            }
                          }
                          return null;
                        })}
                      </ul>
                    </div>
                  </Accordion.Content>
                </Accordion>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
  
}

export default Reports;